export default "/images/0ec245610430f7f1d062a2768914b5ae.jpg";